import {IElement, ITextSelectionInformation} from './types';
import * as resolvers from './resolvers';

export const resolver = ( element: IElement, command: string, value: any, commandChangeValue?: any, textSelectionInformation?: ITextSelectionInformation, notSave?: boolean, commandOrigin?: string): IElement => {
    let updateElement = {} as IElement;
    const restoreTextSelection = (notSave===true?false:true);

    switch(command) {
        case "fontFamily":
          updateElement = resolvers.fontFamilyResolver(element, value, textSelectionInformation);
          break;
        case "fontSize":
          updateElement = resolvers.fontSizeResolver(element,value, textSelectionInformation);
          break;
        case "fontWeight":
          updateElement = resolvers.fontWeightResolver(element, value, textSelectionInformation);
          break;
        case "fontItalic":
          updateElement = resolvers.fontItalicResolver(element, value, textSelectionInformation);
          break;
        case "fontUnderline":
          updateElement = resolvers.fontUnderlineResolver(element, value, textSelectionInformation);
          break;
        case "textAlign":
          updateElement = resolvers.fontAlignmentResolver(element, value);
          break;
        case "resize":          
          updateElement = resolvers.resizeResolver(element, value);
          break;
        case "letterSpacing":
          updateElement = resolvers.fontLetterSpacingResolver(element, value, textSelectionInformation, restoreTextSelection);
          break;
        case "lineHeight":
          updateElement = resolvers.fontLineHeightResolver(element, value, textSelectionInformation, restoreTextSelection);
          break;
        case "color":
          updateElement = resolvers.fontColorResolver(element, value, textSelectionInformation);
          break;
        case "bgcolor":
          updateElement = resolvers.backgroundColorResolver(element, value);
          break;
        case "flip":
          updateElement = resolvers.flipResolver(element, value);
          break;
        case "text":
          updateElement = resolvers.textResolver(element,value);
          break;
        case "fontUpperCase":
          updateElement = resolvers.fontUppercaseResolver(element,value, textSelectionInformation);
          break;
        case "subscript":
          updateElement = resolvers.fontSubscriptResolver(element,value, textSelectionInformation);
          break;
        case "superscript":
          updateElement = resolvers.fontSuperscriptResolver(element, value, textSelectionInformation);
          break;
        case "addElement":
          updateElement = resolvers.addElement(element, {element: value});
          break;
        case "srcImage":
          updateElement = resolvers.updateSrcImage(element, value);
          break;
        case "brandImage":
            updateElement = resolvers.updateBrandImage(element, value);
            break;
        case "removeElement":
          updateElement = resolvers.removeElementResolver(element, value, commandChangeValue);
          break;
        case "opacity":
          updateElement = resolvers.opacityResolver(element, value);
          break;
        case "copypaste":
          updateElement = resolvers.addElement(element, value);
          break;
        case "colorOverlay":
            updateElement = resolvers.colorOverlayResolver(element, value);            
            break;
        case "bgGradient":
            updateElement = resolvers.bgGradientResolver(element, value);            
            break;
        case "hideUnhide":
          updateElement = resolvers.hideUnhideResolver(element, value, commandOrigin);
          break;
        case "borderWidth":
          updateElement = resolvers.borderWidthResolver(element, value);
          break;
        case "borderDash":
          updateElement = resolvers.borderDashResolver(element, value);
          break;
        case "borderSpace":
          updateElement = resolvers.borderSpaceResolver(element, value);
          break;
        case "cornerRadius":
          updateElement = resolvers.cornerRadiusResolver(element, value);
          break;
        case "borderColor":
          updateElement = resolvers.borderColorResolver(element, value);
          break;
        case "updateTextElement":
          updateElement = resolvers.updateTextElementResolver(element, value);
          break;
        case "resizeArtboard":   
          updateElement = resolvers.resizeArtboardResolver(element, value);
          break;
        case "editName":
          updateElement= resolvers.editNameResolver(element,value);
          break;
        case "lockUnlockElement":   
          updateElement = resolvers.lockUnlockResolver(element, value);
          break;
        case "":
          break;
        default:

    }
    return updateElement;
}